import React, { useState } from 'react';
import { useProfileData } from '../../NecttosComp/APICaller/queryHooks';
import { Header, Main, Body } from '../../NecttosComp/Layout/Layout';
import Input2 from '../../NecttosComp/Input/Input2';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import LoadingAnimation from '../../components/LoadingAnimation';
import Button from '../../NecttosComp/Button/Button';
import TimerFunction from './TimerFunction';

function GiveWay({ userId, isStudent, stateData, TimerFunction,startDateTimer,setStateData, onClose }) {
    const { data: userDetail, status } = useProfileData(userId, !isStudent);
    const [state, setState] = useState({});

    if (!userId) {
        return (
            <div>
                <div>Select A User First</div>
            </div>
        );
    }
    const handleCancel = () => {
        setStateData({ ...stateData, [userDetail._id + 'proceed']: false, handleGiveTime: false });
    };

    let memberData = userDetail?.pendingData;

    const handleProceed = async () => {
        try {
            let data = {
                _id: userDetail?.userId,
                extendedTime: state?.extendedTime,
                extendedReason: state?.extendedReason,
            };
            const instance = await getAxiosTokenInstance();
            let resp;
            resp = await instance.post('/college/admissionProcess2/setData', data);
            if (resp.data.statusCode !== 200) {
                console.log(resp.data.message
                );

            } else {
                setStateData({
                    ...stateData,
                    handleGiveTime: false,
                });
            }
        } catch (error) {
            console.log(error?.response?.data?.message || error?.message || 'API Error');
        } finally {
        }
    };

    return (
        <Main width='70%' height='80%' title='Give Time'>
            <Header>
                <div></div>
                <div className='flex justify-end'>
                    <Button type='close' onClick={onClose}>
                        close
                    </Button>
                </div>
            </Header>
            <Body>
                <div>
                    <div>
                        <div>
                            {status === 'loading' && <LoadingAnimation dark />}
                            {status === 'success' && (
                                <div className="flex flex-row items-start justify-between m-5 gap-10">
                                    <div className="flex flex-col items-center w-1/2">
                                        <img
                                            src={userDetail?.photoURL}
                                            className="border-4 border-navy rounded-[10%] w-[80%] h-auto mb-4"
                                        />
                                        <h5 className="text-xl font-semibold">{memberData?.name}</h5>
                                    </div>


                                    <div className="flex flex-col w-1/2 space-y-5">

                                        <TimerFunction
                                            start={true}
                                            date={startDateTimer}
                                            className="text-xl font-mono w-[100%] text-center rounded-lg p-3 ml-1 h-[40px] flex justify-center items-center  dark:bg-neutral-700 dark:text-slate-100   bg-slate-100 text-slate-800"
                                        />

                                        <Input2
                                            keyId="extendedTime"
                                            returnKey="extendedTime"
                                            fieldName="Time Extend*"
                                            type="time"
                                            state={state}
                                            setState={setState}
                                            required={true}
                                        />

                                        <Input2
                                            keyId="extendedReason"
                                            returnKey="extendedReason"
                                            fieldName="Reason For Extend*"
                                            type="text"
                                            state={state}
                                            setState={setState}
                                            required={true}
                                        />





                                        <div className="flex flex-row justify-center gap-4 mt-4">
                                            <Button type="close" onClick={handleCancel}>
                                                Delete
                                            </Button>
                                            <Button type="print" onClick={handleProceed}>
                                                Proceed
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </Body>
        </Main>
    );
}

export default GiveWay;
